import { render, staticRenderFns } from "./IssueHome.vue?vue&type=template&id=d3435c3e&scoped=true&class=template"
import script from "./IssueHome.vue?vue&type=script&lang=js"
export * from "./IssueHome.vue?vue&type=script&lang=js"
import style0 from "./IssueHome.vue?vue&type=style&index=0&id=d3435c3e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3435c3e",
  null
  
)

export default component.exports